module.exports = __webpack_public_path__ + "static/img/icon_sdk.7c21155.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/home/imgs/product-service/icon_sdk.png
// module id = VM2N
// module chunks = 0